<template>
  <span
    class="shiny-text"
    :class="{
      'is-disabled': disabled,
      'is-reverse': reverse,
      'is-yoyo': yoyo
    }"
    :style="shinyTextStyle"
  >
    {{ text }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({
  name: 'ShinyText'
})

const props = defineProps({
  text: {
    type: String,
    default: ''
  },
  color: {
    type: String,
    default: '#b5b5b5'
  },
  shineColor: {
    type: String,
    default: '#ffffff'
  },
  spread: {
    type: String,
    default: '120deg'
  },
  speed: {
    type: String,
    default: '2s'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  reverse: {
    type: Boolean,
    default: false
  },
  yoyo: {
    type: Boolean,
    default: false
  },
  // 不传则不设置 font-size，沿用父级样式
  fontSize: {
    type: String,
    default: ''
  }
})

const shinyTextStyle = computed(() => {
  const style = {
    '--shiny-text-color': props.color,
    '--shiny-text-shine-color': props.shineColor,
    '--shiny-text-spread': props.spread,
    '--shiny-text-speed': props.speed
  }

  if (props.fontSize) {
    style.fontSize = props.fontSize
  }

  return style
})
</script>

<style lang="scss" scoped>
.shiny-text {
  display: inline-block;
  color: var(--shiny-text-color);
  background-image: linear-gradient(
    var(--shiny-text-spread),
    var(--shiny-text-color) 0%,
    var(--shiny-text-color) 35%,
    var(--shiny-text-shine-color) 50%,
    var(--shiny-text-color) 65%,
    var(--shiny-text-color) 100%
  );
  background-size: 200% auto;
  background-position: 150% center;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shinyText var(--shiny-text-speed) linear infinite;
}

.shiny-text:hover {
  animation-play-state: paused;
}

.shiny-text.is-disabled {
  animation: none;
  background-position: center;
}

.shiny-text.is-reverse {
  animation-name: shinyTextReverse;
}

.shiny-text.is-yoyo {
  animation-direction: alternate;
}

@keyframes shinyText {
  from {
    background-position: 150% center;
  }

  to {
    background-position: -50% center;
  }
}

@keyframes shinyTextReverse {
  from {
    background-position: -50% center;
  }

  to {
    background-position: 150% center;
  }
}
</style>
